module.exports = __webpack_public_path__ + "static/media/cognition.042c19c9.png";